var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-simplemde',_vm._b({ref:"markdownEditor",staticClass:"text-editor",attrs:{"value":_vm.value,"preview-class":"markdown-body","configs":_vm.configs},on:{"input":_vm.onInput}},'vue-simplemde',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }